import { Button } from '#app/components/ui/button.tsx'
import {
	findDefaultBranchedGrades,
	findVerticalGrades,
} from '#app/modules/personnel-system/competency/grades.ts'

const level = 6

export default function Page() {
	return (
		<main className="container">
			<section className="ml-2 mt-4">
				<h1 className="py-2  text-2xl font-light leading-[100%] text-[#232323]">
					垂直型・分岐型イメージ
				</h1>
			</section>
			<section className="overflow-x-auto">
				<div className="flex">
					<LevelFrame level={level} grades={findVerticalGrades(level) ?? []} />
					<LevelBranchFrame
						level={level}
						grades={findDefaultBranchedGrades(level) ?? []}
					/>
				</div>
			</section>
			<section className="mt-8">
				<div className="flex justify-center">
					<Button
						variant={'outline'}
						className="bg-white font-semibold"
						onClick={() => {
							window.close()
						}}
					>
						閉じる
					</Button>
				</div>
			</section>
		</main>
	)
}

const LevelFrame = ({ level, grades }: { level: number; grades: any[] }) => {
	return (
		<div className="mx-2 mt-12 flex items-start justify-center">
			<div className="inline-flex flex-col items-center rounded-lg border  bg-white p-8">
				<div className="flex flex-col items-center">
					<div>
						<label className="ml-2 text-center  text-2xl font-light leading-[100%] text-[#232323]">
							{level}段階 - 垂直型
						</label>
					</div>
					{grades.map((grade, gradeIndex) => (
						<GradeLevelLabel
							key={gradeIndex}
							label={grade.label}
							name={grade.name ?? grade.term}
						/>
					))}
				</div>
			</div>
		</div>
	)
}

const LevelBranchFrame = ({
	level,
	grades,
}: {
	level: number
	grades: any[]
}) => {
	const generals = grades.filter(grade => grade.type === 'general')
	const managers = grades.filter(grade => grade.type === 'manager')
	const specialists = grades.filter(grade => grade.type === 'specialist')
	return (
		<div className="mx-2 mt-12 flex items-start justify-center">
			<div className="inline-flex flex-col items-center rounded-lg border  bg-white p-8">
				<div className="flex flex-col items-center">
					<div>
						<label className="ml-2 text-center  text-2xl font-light leading-[100%] text-[#232323]">
							{level}段階 - 分岐型
						</label>
					</div>
					<div className="flex gap-4">
						<div className="flex-col">
							{managers.map((grade, gradeIndex) => (
								<GradeLevelLabel
									key={gradeIndex}
									label={grade.label}
									name={grade.name ?? grade.term}
								/>
							))}
						</div>
						<div className="flex-col">
							{specialists.map((grade, gradeIndex) => (
								<GradeLevelLabel
									key={gradeIndex}
									label={grade.label}
									name={grade.name ?? grade.term}
								/>
							))}
						</div>
					</div>
					{generals.map((grade, gradeIndex) => (
						<GradeLevelLabel
							key={gradeIndex}
							label={grade.label}
							name={grade.name ?? grade.term}
						/>
					))}
				</div>
			</div>
		</div>
	)
}

const GradeLevelLabel = ({ label, name }: { label: string; name: string }) => (
	<div className=" mt-2 flex items-start">
		<div className="flex h-[42px] items-start rounded-bl rounded-tl  bg-[#068cb7] px-2 py-3  font-light leading-[100%] text-white">
			{label}
		</div>
		<div className="flex h-[42px] w-[260px] items-center gap-2 rounded-br rounded-tr border-b border-r border-t border-b-[#dedede] border-r-[#dedede] border-t-[#dedede] bg-[#f0f0f0] p-2">
			<div className="text-2  font-light leading-[100%] text-[#232323]">
				{name}
			</div>
		</div>
	</div>
)
